/* enquiry-zero-fix v2 2026-07-23T23:12 */
(function(){
  /* ============================================================
     Reveal animations
     ============================================================ */
  if (!('IntersectionObserver' in window)){
    document.querySelectorAll('.press-page .reveal').forEach(function(el){ el.classList.add('is-revealed'); });
  } else {
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-revealed'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.press-page .reveal').forEach(function(el){ obs.observe(el); });
  }

  /* ============================================================
     Page data
     ============================================================ */
  var data;
  try { data = JSON.parse(document.getElementById('rv9-data').textContent); }
  catch(e){ data = { viewers:'', currency:'AED', packages:null, variants:[] }; }
  var packages = data.packages || {};
  var variants = data.variants || [];
  var currency = data.currency || 'AED';

  function parseAudienceCount(s){
    if (!s) return 0;
    s = String(s).trim().toLowerCase().replace(/[+,\s]/g, '');
    var m = s.match(/^([\d.]+)\s*([km])?/);
    if (!m) return 0;
    var n = parseFloat(m[1]); if (m[2]==='k') n*=1000; if (m[2]==='m') n*=1000000;
    return Math.round(n);
  }
  var dailyReaders = parseAudienceCount(data.viewers || data.listeners);

  /* ============================================================
     Variant picker logic
     ============================================================ */
  function getSelectedOptions(){
    var opts = [];
    document.querySelectorAll('input[data-option-input]:checked').forEach(function(i){
      var pos = parseInt(i.getAttribute('data-option-position'), 10) || (opts.length + 1);
      opts[pos-1] = i.value;
    });
    return opts.filter(function(v){ return v != null; });
  }
  function findVariant(opts){
    if (!variants.length || !opts.length) return null;
    for (var i=0; i<variants.length; i++){
      var v = variants[i];
      if (!v.options || v.options.length !== opts.length) continue;
      var match = true;
      for (var j=0; j<opts.length; j++){
        if (String(v.options[j]).trim() !== String(opts[j]).trim()){ match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }
  function findPackage(name){
    if (!name || !packages) return null;
    if (packages[name]) return packages[name];
    var keys = Object.keys(packages);
    for (var i=0; i<keys.length; i++) if (keys[i].toLowerCase() === String(name).toLowerCase()) return packages[keys[i]];
    return null;
  }
  function multiplier(s){ if (!s) return 1; var m = String(s).match(/(\d+)/); return m ? parseInt(m[1],10) : 1; }
  function formatMoney(amount){
    return amount.toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 });
  }
  function nextStart(pkg, lengthStr){
    var d = (pkg.days_label||'').toLowerCase();
    var startDay;
    if (d.indexOf('friday')>=0 && (d.indexOf('saturday')>=0 || /weekend/i.test(lengthStr||''))) startDay = 5;
    else if (d.indexOf('sunday')>=0) startDay = 0;
    else if (d.indexOf('monday')>=0) startDay = 1;
    else return null;
    var today = new Date();
    var diff = (startDay - today.getDay() + 7) % 7;
    if (diff === 0) diff = 7; diff += 7;
    var dt = new Date(today); dt.setDate(today.getDate() + diff);
    return dt.toLocaleDateString(undefined, { weekday:'long', month:'long', day:'numeric' });
  }

  /* ============================================================
     Update on variant change
     ============================================================ */
  var idInput = document.querySelector('[data-variant-id-input]');
  var totalEl = document.querySelector('[data-total]');
  var summaryEl = document.querySelector('[data-summary]');
  var addCtaLabel = document.querySelector('[data-add-cta-label]');
  var addCta = document.querySelector('[data-add-cta]');
  var qtyInput = document.querySelector('[data-qty-input]');

  // Read the package-to-valid-lengths map embedded server-side
  var lengthMap = {};
  try { lengthMap = JSON.parse(document.getElementById('rv9-length-map').textContent) || {}; }
  catch(e){ lengthMap = {}; }

  // Rebuild the Length group's segments based on the currently-checked package.
  function rebuildLengthGroup(){
    var pkgInput = document.querySelector('input[data-option-input][data-option-position="1"]:checked');
    if (!pkgInput) return;
    var pkg = pkgInput.value;
    var validLengths = lengthMap[pkg] || [];
    var lengthGroup = document.querySelector('[data-length-group]');
    if (!lengthGroup) return;

    // Preserve currently-selected length if still valid
    var currentLengthInput = lengthGroup.querySelector('input[data-option-input]:checked');
    var currentLength = currentLengthInput ? currentLengthInput.value : null;
    var keepLength = currentLength && validLengths.indexOf(currentLength) >= 0 ? currentLength : (validLengths[0] || null);

    // Build new HTML
    var html = '';
    for (var i=0; i<validLengths.length; i++){
      var val = validLengths[i];
      var isLast = i === validLengths.length - 1;
      var checked = val === keepLength ? ' checked' : '';
      var lastCls = isLast ? ' is-last-visible' : '';
      var safe = String(val).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
      html += '<label class="seg' + lastCls + '">'
        +    '<input type="radio" name="options[Length]" value="' + safe + '"' + checked + ' data-option-input data-option-position="2">'
        +    '<span class="seg-label">' + safe + '</span>'
        +  '</label>';
    }
    lengthGroup.innerHTML = html;

    // Re-wire change events on the new inputs
    lengthGroup.querySelectorAll('input[data-option-input]').forEach(function(inp){
      inp.addEventListener('change', updateVariantState);
    });
  }

  function updateVariantState(){
    var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
    if (qty < 1) qty = 1;

    rebuildLengthGroup();

    // Now compute the final variant + summary from current selections
    var opts = getSelectedOptions();
    var v = findVariant(opts);
    var pkg = findPackage(opts[0]);

    if (v){
      if (idInput) idInput.value = v.id;
      var unitPrice = v.price / 100;
      var total = unitPrice * qty;
      if (totalEl) totalEl.innerHTML = (v.price === 0) ? 'Rates on enquiry' : (formatMoney(total) + ' <small>' + currency + '</small>');
      if (addCta){
        addCta.disabled = (v.price !== 0) && !v.available;
        if (addCtaLabel) addCtaLabel.textContent = (v.price === 0) ? 'Send a brief' : (v.available ? 'Add to cart' : 'Unavailable');
      }
    } else {
      if (totalEl) totalEl.innerHTML = '- <small>' + currency + '</small>';
      if (addCta){ addCta.disabled = true; if (addCtaLabel) addCtaLabel.textContent = 'Unavailable'; }
    }

    // Render summary (package details)
    if (summaryEl){
      if (!pkg || opts.length < 1){
        summaryEl.innerHTML = '<div class="summary-eyebrow">What you\'re getting</div><p style="font-size:14px; color: var(--ink-56); margin:4px 0;">Pick a package above to see what\'s included.</p>';
      } else {
        var mult = multiplier(opts[1] || '');
        var totalSpots = (pkg.spots_per_unit || 0) * mult;
        var unitLabel = mult === 1 ? (pkg.unit_singular || 'Week') : (pkg.unit_plural || 'Weeks');
        var dSing = pkg.deliverable_singular || 'ad';
        var dPlur = pkg.deliverable_plural || 'ads';
        var totalLabel = totalSpots === 1 ? dSing : dPlur;
        var html = '<div class="summary-eyebrow">What you\'re getting</div>'
          + '<h3 class="summary-h">' + totalSpots + ' ' + totalLabel + ' in total</h3>'
          + '<div class="summary-meta">' + mult + ' ' + unitLabel
          + (pkg.days_label ? ' · ' + pkg.days_label : '')
          + (pkg.ad_duration_seconds ? ' · ' + pkg.ad_duration_seconds + '-second spots' : '')
          + '</div>';
        if (pkg.time_bands && pkg.time_bands.length){
          html += '<div class="pkg-bands-h" style="margin-bottom:14px;">Time bands</div><div class="summary-bands">';
          pkg.time_bands.forEach(function(b){
            var spots = b.spots_per_day || 0;
            var sLabel = spots === 1 ? dSing : dPlur;
            html += '<div class="summary-band">'
              + '<span class="summary-band-time">' + (b.label||'') + '</span>'
              + '<span class="summary-band-name">' + (b.daypart||'') + '</span>'
              + '<span class="summary-band-rate">' + spots + ' ' + sLabel + '/day</span>'
              + '</div>';
          });
          html += '</div>';
        }
        if (dailyReaders > 0 && totalSpots > 0){
          var aqh = Math.round(dailyReaders * 0.15);
          var totalImp = aqh * totalSpots;
          var unitPriceForCpm = null;
          if (v && v.price) unitPriceForCpm = v.price / 100;
          else if (data.price_min) unitPriceForCpm = data.price_min / 100;
          var cpm = (unitPriceForCpm && totalImp > 0) ? Math.round((unitPriceForCpm / totalImp) * 1000) : null;
          html += '<div class="summary-totals">'
            + '<div class="summary-total"><div class="lbl">Est. reach per spot</div><div class="val">' + aqh.toLocaleString() + '</div></div>'
            + '<div class="summary-total"><div class="lbl">Total impressions</div><div class="val">' + totalImp.toLocaleString() + '</div></div>'
            + '<div class="summary-total"><div class="lbl">Cost per 1,000 reached</div><div class="val">' + (cpm ? (currency + ' ' + cpm) : '-') + '</div></div>'
            + '</div>';
        }
        html += '<p class="summary-foot">Estimated based on station\'s daily audience and quarter-hour averages. Often cheaper than digital display in this market. Published reach available on request.</p>';
        var nd = nextStart(pkg, opts[1]);
        if (nd) html += '<div class="availability"><span class="check"></span><span>Next available start: <strong style="margin-left:4px;">' + nd + '</strong></span></div>';
        summaryEl.innerHTML = html;
      }
    }

    // Update sticky bar
    updateSticky(opts, v, qty);
  }

  // Wire variant pickers
  document.querySelectorAll('input[data-option-input]').forEach(function(input){
    var label = input.parentElement && input.parentElement.querySelector('.seg-label');
    input.addEventListener('change', updateVariantState);
  });

  // Quantity (guarded; buy widget may be absent on some products)
  var qtyMinusBtn = document.querySelector('[data-qty-minus]');
  var qtyPlusBtn = document.querySelector('[data-qty-plus]');
  if (qtyMinusBtn) qtyMinusBtn.addEventListener('click', function(){
    if (!qtyInput) return;
    var v = parseInt(qtyInput.value, 10) || 1; qtyInput.value = Math.max(1, v - 1); updateVariantState();
  });
  if (qtyPlusBtn) qtyPlusBtn.addEventListener('click', function(){
    if (!qtyInput) return;
    var v = parseInt(qtyInput.value, 10) || 1; qtyInput.value = v + 1; updateVariantState();
  });
  if (qtyInput) qtyInput.addEventListener('input', updateVariantState);

  /* ============================================================
     LIVE AUDIO PLAYER
     ============================================================ */
  (function(){
    var audio = document.getElementById('rv9-stream');
    if (!audio) return;
    var streamUrl = audio.getAttribute('data-stream-url');
    if (!streamUrl) return;
    var triggers = document.querySelectorAll('[data-listen-trigger]');
    var errEl = document.querySelector('[data-listen-error]');
    var hlsLoaded = false;
    function setState(s){ triggers.forEach(function(b){ b.setAttribute('data-state', s); }); }
    function showError(){ if (errEl) errEl.hidden = false; setState('paused'); }
    function loadHls(cb){
      if (hlsLoaded || window.Hls) return cb();
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.13/dist/hls.min.js';
      s.onload = function(){ hlsLoaded = true; cb(); };
      s.onerror = showError;
      document.head.appendChild(s);
    }
    function attach(){
      var isHls = /\.m3u8(\?|$)/i.test(streamUrl);
      if (isHls && window.Hls && window.Hls.isSupported()){
        var hls = new window.Hls({ liveSyncDuration: 6 });
        hls.loadSource(streamUrl); hls.attachMedia(audio);
        hls.on(window.Hls.Events.ERROR, function(_, d){ if (d.fatal) showError(); });
      } else { audio.src = streamUrl; }
    }
    function play(){
      setState('loading'); if (errEl) errEl.hidden = true;
      var go = function(){ attach(); var pp = audio.play(); if (pp && pp.catch) pp.catch(showError); };
      // Native HLS playback only works reliably on Safari (returns 'probably').
      // Chrome/Firefox/Edge return 'maybe' but actually fail with DEMUXER_ERROR_COULD_NOT_PARSE,
      // so for any non-Safari HLS we force hls.js.
      var isHls = /\.m3u8(\?|$)/i.test(streamUrl);
      var nativeHls = audio.canPlayType('application/vnd.apple.mpegurl') === 'probably';
      if (isHls && !nativeHls) loadHls(go);
      else go();
    }
    audio.addEventListener('playing', function(){ setState('playing'); });
    audio.addEventListener('pause', function(){ setState('paused'); });
    audio.addEventListener('error', showError);
    triggers.forEach(function(b){ b.addEventListener('click', function(){ if (audio.paused) play(); else audio.pause(); }); });
  })();

  /* ============================================================
     FAQ accordion
     ============================================================ */
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ============================================================
     SHARE button
     ============================================================ */
  (function(){
    var wrap = document.querySelector('[data-share-wrap]');
    if (!wrap) return;
    var trigger = wrap.querySelector('[data-share-trigger]');
    var menu = wrap.querySelector('[data-share-menu]');
    var copyBtn = wrap.querySelector('[data-share-action="copy"]');
    var emailBtn = wrap.querySelector('[data-share-action="email"]');
    var waBtn = wrap.querySelector('[data-share-action="whatsapp"]');
    var liBtn = wrap.querySelector('[data-share-action="linkedin"]');
    var copyLabel = wrap.querySelector('[data-share-copy-label]');
    var titleEl = document.querySelector('.hero-name');
    var taglineEl = document.querySelector('.hero-tagline');
    var stationName = (titleEl && titleEl.textContent || document.title).trim();
    var tagline = (taglineEl && taglineEl.textContent || '').trim();
    var url = window.location.href.split('#')[0].split('?')[0];
    var shareText = tagline ? (stationName + ': ' + tagline) : stationName;
    if (emailBtn) emailBtn.href = 'mailto:?subject=' + encodeURIComponent('Press advertising - ' + stationName) + '&body=' + encodeURIComponent('Take a look at this package on ' + stationName + ':\n\n' + url);
    if (waBtn) waBtn.href = 'https://wa.me/?text=' + encodeURIComponent(shareText + '\n\n' + url);
    if (liBtn) liBtn.href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url);
    if (copyBtn){
      copyBtn.addEventListener('click', function(){
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function(){
          if (copyLabel){ copyLabel.textContent = 'Copied'; setTimeout(function(){ copyLabel.textContent = 'Copy link'; }, 2000); }
        });
      });
    }
    function toggleMenu(){
      if (menu.hasAttribute('hidden')) menu.removeAttribute('hidden');
      else menu.setAttribute('hidden','');
    }
    trigger.addEventListener('click', function(e){
      e.stopPropagation();
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)){
        navigator.share({title: stationName, text: shareText, url: url}).catch(toggleMenu);
      } else { toggleMenu(); }
    });
    document.addEventListener('click', function(e){ if (!wrap.contains(e.target)) menu.setAttribute('hidden',''); });
    document.addEventListener('keydown', function(e){ if (e.key==='Escape') menu.setAttribute('hidden',''); });
  })();

  /* ============================================================
     SAVE / SHORTLIST
     ============================================================ */
  (function(){
    var KEY = 'media_co_uk_saved';
    function read(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
    function write(list){
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
      document.dispatchEvent(new CustomEvent('media-saved:changed', { detail: list }));
    }
    window.MediaSaved = window.MediaSaved || {
      get: read,
      isSaved: function(h){ return read().some(function(s){ return s.handle === h; }); },
      add: function(item){ var list = read(); if (list.some(function(s){ return s.handle === item.handle; })) return list; item.addedAt = new Date().toISOString(); list.unshift(item); write(list); return list; },
      remove: function(h){ var list = read().filter(function(s){ return s.handle !== h; }); write(list); return list; },
      toggle: function(item){ return read().some(function(s){ return s.handle === item.handle; }) ? this.remove(item.handle) : this.add(item); },
      clear: function(){ write([]); }
    };

    var pill = document.getElementById('rv9-save-pill');
    var drawer = document.getElementById('rv9-save-drawer');
    if (!pill || !drawer) return;
    var countEl = pill.querySelector('[data-save-count]');
    var countHeader = drawer.querySelector('[data-save-count-header]');
    var listEl = drawer.querySelector('[data-save-list]');
    var emptyEl = drawer.querySelector('[data-save-empty]');
    var footerEl = drawer.querySelector('[data-save-footer]');
    var shareBtn = drawer.querySelector('[data-save-share]');
    var shareLabel = drawer.querySelector('[data-save-share-label]');
    var clearBtn = drawer.querySelector('[data-save-clear]');
    var closes = drawer.querySelectorAll('[data-save-close]');

    function escapeHtml(s){ return String(s||'').replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
    function escapeAttr(s){ return escapeHtml(s).replace(/"/g,'&quot;'); }

    function renderList(){
      var list = MediaSaved.get();
      if (countEl) countEl.textContent = list.length;
      if (list.length === 0) pill.setAttribute('hidden',''); else pill.removeAttribute('hidden');
      if (countHeader) countHeader.textContent = '(' + list.length + ')';
      var existing = listEl.querySelectorAll('.rv9-save-card');
      existing.forEach(function(c){ c.remove(); });
      if (list.length === 0){
        if (emptyEl) emptyEl.removeAttribute('hidden');
        if (footerEl) footerEl.setAttribute('hidden','');
      } else {
        if (emptyEl) emptyEl.setAttribute('hidden','');
        if (footerEl) footerEl.removeAttribute('hidden');
        list.forEach(function(item){
          var card = document.createElement('a');
          card.className = 'rv9-save-card';
          card.href = item.url;
          card.innerHTML = ''
            + '<div class="rv9-save-card-img">' + (item.logo ? '<img src="' + escapeAttr(item.logo) + '" alt="">' : '') + '</div>'
            + '<div>'
            +   '<div class="rv9-save-card-title">' + escapeHtml(item.title) + '</div>'
            +   '<div class="rv9-save-card-meta">' + escapeHtml(item.country || item.format || 'Press') + '</div>'
            + '</div>'
            + '<button type="button" class="rv9-save-card-remove" data-save-handle="' + escapeAttr(item.handle) + '" aria-label="Remove">'
            +   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            + '</button>';
          listEl.appendChild(card);
        });
      }
    }
    function open(){ drawer.removeAttribute('hidden'); requestAnimationFrame(function(){ drawer.setAttribute('data-open','true'); }); document.body.style.overflow='hidden'; }
    function close(){ drawer.setAttribute('data-open','false'); setTimeout(function(){ drawer.setAttribute('hidden',''); document.body.style.overflow=''; }, 280); }
    pill.addEventListener('click', open);
    closes.forEach(function(c){ c.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && !drawer.hasAttribute('hidden')) close(); });
    listEl.addEventListener('click', function(e){
      var btn = e.target && e.target.closest && e.target.closest('[data-save-handle]');
      if (btn){ e.preventDefault(); MediaSaved.remove(btn.getAttribute('data-save-handle')); }
    });
    if (shareBtn){
      shareBtn.addEventListener('click', function(){
        var list = MediaSaved.get(); if (!list.length) return;
        var origin = window.location.origin;
        var text = "My shortlist on Media.co.uk:\n\n" + list.map(function(s,i){ return (i+1)+'. '+s.title+(s.country?' ('+s.country+')':'')+'\n   '+origin+s.url; }).join('\n\n');
        if (navigator.clipboard){ navigator.clipboard.writeText(text).then(function(){
          if (shareLabel){ shareLabel.textContent = 'Copied'; setTimeout(function(){ shareLabel.textContent = 'Copy my list'; }, 2000); }
        }); }
      });
    }
    if (clearBtn) clearBtn.addEventListener('click', function(){ if (confirm('Clear all saved items?')) MediaSaved.clear(); });

    var saveBtn = document.querySelector('[data-save-trigger]');
    var saveLabel = saveBtn && saveBtn.querySelector('[data-save-label]');
    if (saveBtn){
      function syncSaveBtn(){
        var saved = MediaSaved.isSaved(saveBtn.getAttribute('data-handle'));
        saveBtn.setAttribute('data-saved', saved ? 'true' : 'false');
        if (saveLabel) saveLabel.textContent = saved ? 'Saved' : 'Save';
      }
      saveBtn.addEventListener('click', function(){
        MediaSaved.toggle({
          handle: saveBtn.getAttribute('data-handle'),
          title: saveBtn.getAttribute('data-title'),
          url: saveBtn.getAttribute('data-url'),
          logo: saveBtn.getAttribute('data-logo'),
          country: saveBtn.getAttribute('data-country'),
          listeners: saveBtn.getAttribute('data-listeners'),
          format: saveBtn.getAttribute('data-format')
        });
      });
      syncSaveBtn();
      document.addEventListener('media-saved:changed', syncSaveBtn);
    }
    document.addEventListener('media-saved:changed', renderList);
    renderList();
  })();

  /* ============================================================
     STICKY BUY BAR
     ============================================================ */
  function updateSticky(opts, variant, qty){
    var bar = document.getElementById('rv9-sticky');
    if (!bar) return;
    var nameEl = bar.querySelector('[data-sticky-variant]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var addBtn = bar.querySelector('[data-sticky-add]');
    if (nameEl && opts) nameEl.textContent = opts.join(' · ');
    if (priceEl && variant){
      var t = (variant.price/100) * (qty||1);
      priceEl.textContent = (variant.price === 0) ? 'On enquiry' : (currency + ' ' + t.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}));
    }
    if (addBtn && variant){
      /* Enquiry-only listings (price 0) are deliberately not purchasable: as of 2026-08-17 their
         variants are inventoryPolicy DENY so Shopify refuses a $0 order. Without this branch the
         bar would read "Unavailable", which reads as sold out and misrepresents the owner's
         inventory. Mirror the OOH bar and send the buyer to the brief instead. */
      if (variant.price === 0){
        addBtn.disabled = false;
        addBtn.textContent = 'Send a brief';
      } else {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Unavailable';
      }
    }
  }
  (function(){
    var bar = document.getElementById('rv9-sticky');
    var addBtn = bar && bar.querySelector('[data-sticky-add]');
    if (addBtn){
      addBtn.addEventListener('click', function(){
        /* On enquiry-only pages the buy widget renders a brief link, not an add-to-cart button. */
        var realBtn = document.querySelector('[data-add-cta]') || document.querySelector('[data-scroll-brief]');
        if (realBtn){
          realBtn.click();
          var buy = document.getElementById('buy');
          if (buy) buy.scrollIntoView({behavior:'smooth', block:'center'});
        }
      });
    }
    function checkVisibility(){
      var buyBox = document.getElementById('buy');
      if (!buyBox || !bar) return;
      var rect = buyBox.getBoundingClientRect();
      var passed = rect.bottom < 100;
      var scrolled = window.scrollY > 400;
      var atFooter = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 80);
      var should = passed && scrolled && !atFooter;
      bar.setAttribute('data-show', should ? 'true' : 'false');
      if (should) bar.removeAttribute('hidden');
    }
    window.addEventListener('scroll', checkVisibility, {passive:true});
    window.addEventListener('resize', checkVisibility);
    setTimeout(checkVisibility, 600);
  })();

  /* ============================================================
     Initial render
     ============================================================ */
  updateVariantState();
})();